/*
 * @Description: 用户登录模块 API
 */
import { httpRequest } from '@/utils/umiRequest';

/** 退出登录接口 */
export async function outLogin(data = {}, options?: Record<string, any>) {
  return httpRequest.post('/logout', data, options);
}

// 登录后获取的返回值
export interface LoginState {
  access_token: string;
  token_type: string;
  refresh_token: string;
  expires_in: number;
  refresh_token_expires_in: number;
}

/** 登录接口 */
export async function login(data: USERAPI.LoginParams, options?: Record<string, any>) {
  return httpRequest.post<LoginState>('/login', data, options);
}

/** 获取当前的用户 */
export async function queryCurrentUser(options?: Record<string, any>) {
  return httpRequest.get('/me', options);
}

/** 获取项目配置信息 */
export async function fetchConfig(options?: Record<string, any>) {
  return httpRequest.get('/configs', options);
}

/** 获取阿里的token */
export async function getAlioss(options?: Record<string, any>) {
  return httpRequest.get('/resource/ali-oss', options);
}

/** 刷新授权的token */
export async function refreshTokenAPI(data = {}, options?: Record<string, any>) {
  return httpRequest.post<LoginState>('/refresh_token', data, options);
}
